import { memo } from 'react';

import StarsIconSVG from '@/assets/stars-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IStarsIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={StarsIconSVG} {...props} />;

export const StarsIcon = memo(IStarsIcon) as typeof IStarsIcon;
